// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__4e6bp {
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  border: 1px solid #ccc;
  border-radius: 1rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin: 2rem 0;
  gap: 2rem;
}
@media screen and (min-width: 768px) {
  .styles_wrapper__4e6bp {
    padding: 2rem;
  }
}
.styles_wrapper__4e6bp .styles_formHeader__HtbdL {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}
@media screen and (min-width: 768px) {
  .styles_wrapper__4e6bp .styles_formHeader__HtbdL {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
.styles_wrapper__4e6bp .styles_formHeader__HtbdL .styles_titleContainer__-\\+Age {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.styles_wrapper__4e6bp .styles_formHeader__HtbdL .styles_titleContainer__-\\+Age .styles_videoIcon__UmJEW {
  height: 3rem;
  width: 3rem;
  fill: #6ba7a8;
}
.styles_wrapper__4e6bp .styles_formHeader__HtbdL .styles_titleContainer__-\\+Age h1 {
  font-size: 2rem;
  font-weight: 500;
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 16px;
}
@media screen and (min-width: 660px) {
  .styles_wrapper__4e6bp .styles_transcriptArchive__ytScf {
    grid-template-columns: repeat(10, 1fr);
  }
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_filters__jCSM4 {
  display: none;
}
@media screen and (min-width: 660px) {
  .styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_filters__jCSM4 {
    grid-column: span 3;
    padding: 16px;
    border-left: 2px solid #ccc;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_filters__jCSM4 .styles_searchInput__emk7E {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_filters__jCSM4 .styles_searchInput__emk7E:focus {
  outline: none;
  border: 1px solid #6ba7a8;
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_transcriptListWrapper__Ktq7K {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  grid-column: span 7;
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_transcriptListContainer__F-IUW {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
@media screen and (min-width: 768px) {
  .styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_transcriptListContainer__F-IUW {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (min-width: 992px) {
  .styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_transcriptListContainer__F-IUW {
    grid-template-columns: repeat(3, 1fr);
  }
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_transcriptListContainer__F-IUW .styles_noTranscripts__QygGR {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 120px 24px;
  font-weight: 600;
  text-align: center;
  grid-column: span 2;
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_transcriptListContainer__F-IUW .styles_noTranscripts__QygGR .styles_btn__HiL1C {
  padding: 12px 24px;
  border-radius: 12px;
  background-color: #6ba7a8;
  color: #fff;
  text-align: center;
}
.styles_wrapper__4e6bp .styles_transcriptArchive__ytScf .styles_singleTranscriptHeader__aER2y {
  margin-bottom: 1rem;
  pointer-events: none;
  background-color: #6ba7a8;
  color: #fff;
  font-weight: 600;
  border: 1px;
  border-radius: 0.5rem;
  padding: 8px 16px;
  box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptList/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iDAAA;EACA,cAAA;EACA,SAAA;AACF;AAAE;EATF;IAUI,aAAA;EAGF;AACF;AADE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAGJ;AADI;EANF;IAOI,mBAAA;IACA,8BAAA;IACA,mBAAA;EAIJ;AACF;AAFI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAIN;AAFM;EACE,YAAA;EACA,WAAA;EACA,aAAA;AAIR;AADM;EACE,eAAA;EACA,gBAAA;AAGR;AAEE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAAJ;AAEI;EALF;IAMI,sCAAA;EACJ;AACF;AACI;EACE,aAAA;AACN;AACM;EAHF;IAII,mBAAA;IACA,aAAA;IACA,2BAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EAEN;AACF;AAAM;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;AAER;AAAQ;EACE,aAAA;EACA,yBAAA;AAEV;AAGI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AADN;AAII;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAFN;AAIM;EALF;IAMI,qCAAA;EADN;AACF;AAGM;EATF;IAUI,qCAAA;EAAN;AACF;AAEM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAAR;AAEQ;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAAV;AAKI;EACE,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,kDAAA;AAHN","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 2rem 1rem;\n  border: 1px solid #ccc;\n  border-radius: 1rem;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  margin: 2rem 0;\n  gap: 2rem;\n  @media screen and (min-width: 768px) {\n    padding: 2rem;\n  }\n\n  .formHeader {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 24px;\n\n    @media screen and (min-width: 768px) {\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n    }\n\n    .titleContainer {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n\n      .videoIcon {\n        height: 3rem;\n        width: 3rem;\n        fill: #6ba7a8;\n      }\n\n      h1 {\n        font-size: 2rem;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .transcriptArchive {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 16px;\n\n    @media screen and (min-width: 660px) {\n      grid-template-columns: repeat(10, 1fr);\n    }\n\n    .filters {\n      display: none;\n\n      @media screen and (min-width: 660px) {\n        grid-column: span 3;\n        padding: 16px;\n        border-left: 2px solid #ccc;\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n      }\n\n      .searchInput {\n        display: flex;\n        padding: 0.5rem;\n        border: 1px solid #ccc;\n        border-radius: 8px;\n        box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n\n        &:focus {\n          outline: none;\n          border: 1px solid #6ba7a8;\n        }\n      }\n    }\n\n    .transcriptListWrapper {\n      display: flex;\n      flex-direction: column;\n      gap: 2rem;\n      grid-column: span 7;\n    }\n\n    .transcriptListContainer {\n      display: grid;\n      grid-template-columns: 1fr;\n      gap: 16px;\n\n      @media screen and (min-width: 768px) {\n        grid-template-columns: repeat(2, 1fr);\n      }\n\n      @media screen and (min-width: 992px) {\n        grid-template-columns: repeat(3, 1fr);\n      }\n\n      .noTranscripts {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 24px;\n        padding: 120px 24px;\n        font-weight: 600;\n        text-align: center;\n        grid-column: span 2;\n\n        .btn {\n          padding: 12px 24px;\n          border-radius: 12px;\n          background-color: #6ba7a8;\n          color: #fff;\n          text-align: center;\n        }\n      }\n    }\n\n    .singleTranscriptHeader {\n      margin-bottom: 1rem;\n      pointer-events: none;\n      background-color: #6ba7a8;\n      color: #fff;\n      font-weight: 600;\n      border: 1px;\n      border-radius: 0.5rem;\n      padding: 8px 16px;\n      box-shadow: 0px 10px 20px -6px rgba(0, 0, 0, 0.12);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__4e6bp`,
	"formHeader": `styles_formHeader__HtbdL`,
	"titleContainer": `styles_titleContainer__-+Age`,
	"videoIcon": `styles_videoIcon__UmJEW`,
	"transcriptArchive": `styles_transcriptArchive__ytScf`,
	"filters": `styles_filters__jCSM4`,
	"searchInput": `styles_searchInput__emk7E`,
	"transcriptListWrapper": `styles_transcriptListWrapper__Ktq7K`,
	"transcriptListContainer": `styles_transcriptListContainer__F-IUW`,
	"noTranscripts": `styles_noTranscripts__QygGR`,
	"btn": `styles_btn__HiL1C`,
	"singleTranscriptHeader": `styles_singleTranscriptHeader__aER2y`
};
export default ___CSS_LOADER_EXPORT___;
